import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Disclosure } from '@headlessui/react';

/**
 * Mobile version of the user menu component
 */
const MobileUserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  
  // Navigation handlers
  const handleSettingsClick = () => {
    // Direct to security or team based on role
    if (user.role === 'admin') {
      navigate('/admin/team');
    } else {
      navigate('/admin/security');
    }
  };
  
  const handleLogout = async () => {
    const success = await logout();
    if (success) {
      navigate('/login');
    }
  };
  
  return (
    <Disclosure.Panel>
      {({ close }) => (
        <>
          <div className="flex items-center px-5">
            <div className="shrink-0">
              <div className="h-10 w-10 rounded-full bg-indigo-100 dark:bg-indigo-200 flex items-center justify-center text-sm font-medium text-indigo-700 dark:text-indigo-800">
                {user?.email?.charAt(0).toUpperCase() || 'U'}
              </div>
            </div>
            <div className="ml-3">
              <div className="text-base/5 font-medium text-white">{user?.email}</div>
              <div className="text-sm font-medium text-gray-400 capitalize">{user?.role?.replace('_', ' ')}</div>
            </div>
          </div>
          
          <div className="mt-3 space-y-1 px-2">
            <button
              className="block w-full text-left rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white dark:text-gray-300 dark:hover:bg-gray-600"
              onClick={() => {
                close();
                handleSettingsClick();
              }}
            >
              Settings
            </button>
            
            <button
              className="block w-full text-left rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white dark:text-gray-300 dark:hover:bg-gray-600"
              onClick={() => {
                close();
                handleLogout();
              }}
            >
              Sign out
            </button>
          </div>
        </>
      )}
    </Disclosure.Panel>
  );
};

export default MobileUserMenu;